import { useState, useEffect } from 'react';
import SupportRequestType from '@/models/common/SupportRequestType';
import OptionsRangeFilter, { FilterOption } from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';

interface SupportRequestTypeFilterProps {
  selectedTypes: SupportRequestType[];
  onTypesChange: (types: SupportRequestType[]) => void;
}

const SupportRequestTypeFilter = ({ selectedTypes, onTypesChange }: SupportRequestTypeFilterProps) => {
  const [options, setOptions] = useState<FilterOption[]>([
    { id: SupportRequestType.OneTime, label: 'oneTime', checked: false },
    { id: SupportRequestType.Monthly, label: 'monthly', checked: false },
  ]);

  // Sync local state with prop changes
  useEffect(() => {
    setOptions((prev) =>
      prev.map((option) => ({
        ...option,
        checked: selectedTypes.includes(option.id as SupportRequestType),
      }))
    );
  }, [selectedTypes]);

  const handleOptionChange = (optionId: string) => {
    const updatedOptions = options.map((option) => 
      option.id === optionId ? { ...option, checked: !option.checked } : option
    );
    setOptions(updatedOptions);

    const selectedValues = updatedOptions
      .filter((option) => option.checked)
      .map((option) => option.id as SupportRequestType);

    onTypesChange(selectedValues);
  };

  return (
    <OptionsRangeFilter
      title="requestType"
      filterType="options"
      options={options}
      onOptionChange={handleOptionChange}
      selectionType="checkbox"
    />
  );
};

export default SupportRequestTypeFilter;
